export default __webpack_public_path__ + "static/media/eh.f46bfdc1.svg";